import { push } from 'connected-react-router'
import React from 'react'
import { Translate, I18n } from 'react-redux-i18n'
import {
  removeTicketFromBasket,
  addEmailToBasket,
  killBasket,
  setValidEvent
} from '../actions/shopping-basket'
import { ensureValidSession } from '../actions/users'
import { toggleModal } from '../actions/modal'
import * as API from '../utility/api'

import { connect } from 'react-redux'
import BasketEventContainer from './basket-event-container'
import RepresentMoney from '../utility/represent-money'
import FeeInclusivePrice from '../components/resale-pricing/fee-inclusive-price'
import {
  calculateBasketPricingBreakdown,
  loadResalePricingRulesForTickets
} from '../utility/resale-pricing'

class ShoppingBasket extends React.Component {
  state = {
    email: '',
    pricingRulesByDate: null,
    pricingRulesLoading: true
  }

  loadPricingRules = ticketList => {
    this.setState({ pricingRulesLoading: true })

    loadResalePricingRulesForTickets(ticketList).then(pricingRulesByDate => {
      if (this.props.ticketList === ticketList) {
        this.setState({ pricingRulesByDate, pricingRulesLoading: false })
      }
    })
  }

  redirectToHomeIfBasketEmpty = () => {
    const { dispatch, ticketList } = this.props

    if (ticketList.length === 0) {
      dispatch(killBasket())
      dispatch(push('/'))
    }
  }

  componentDidMount() {
    const { userInfo } = this.props

    this.redirectToHomeIfBasketEmpty()

    if (this.props.ticketList.length === 0) {
      return
    }

    if (userInfo) {
      this.props.dispatch(addEmailToBasket(userInfo.email))
    }

    this.loadPricingRules(this.props.ticketList)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ticketList !== this.props.ticketList) {
      if (
        prevProps.ticketList.length > 0 &&
        this.props.ticketList.length === 0
      ) {
        this.redirectToHomeIfBasketEmpty()
        return
      }

      this.loadPricingRules(this.props.ticketList)
    }
  }

  handleChange = e => {
    this.props.dispatch(addEmailToBasket(e.target.value))
  }

  handleToPayment = async e => {
    e.preventDefault()
    const { dispatch } = this.props

    const { isValid, reason } = await dispatch(ensureValidSession())
    if (!isValid) {
      if (reason === 'login_required' || reason === 'session_expired') {
        dispatch(
          toggleModal(
            true,
            '/payment',
            reason === 'session_expired'
              ? 'registration.invalid_login'
              : 'login.login_needed'
          )
        )
      } else if (reason === 'session_check_failed') {
        API.apiNotification({
          value: 'notifications.connection_error',
          status: 'error'
        })
      }
      return
    }

    dispatch(push('/payment'))
  }

  namedValid = (validated, id) => {
    const { dispatch } = this.props
    dispatch(setValidEvent(validated, id))
  }

  allEventsValid = () => {
    const { validEvents } = this.props

    return Object.values(validEvents).every(k => k)
  }

  render() {
    const removeTicketFromBasketFunction = dispatch => {
      return id => {
        return () => {
          dispatch(removeTicketFromBasket(id, true))
        }
      }
    }

    const {
      eventList,
      ticketList,
      email,
      errors,
      dispatch
    } = this.props
    const { pricingRulesByDate, pricingRulesLoading } = this.state
    const pricingBreakdown = calculateBasketPricingBreakdown(
      ticketList,
      pricingRulesByDate || {}
    )
    const showBuyerServiceFee = pricingBreakdown.buyer_service_fee_amount > 0
    const canProceedToPayment =
      this.allEventsValid() && !pricingRulesLoading && pricingRulesByDate

    const eventContainers = eventList.map(event => {
      const eventTickets = ticketList.filter(
        ticket => ticket.event.id === event.id
      )

      if (eventTickets.length > 0) {
        return (
          <BasketEventContainer
            {...event}
            tickets={eventTickets}
            removeTicketFromBasket={removeTicketFromBasketFunction(dispatch)}
            errors={errors}
            key={`basket-event-${event.id}`}
            dispatch={dispatch}
            valid={this.namedValid}
          />
        )
      }

      return <div key={event.id} />
    })

    const summary = ticketList.map(ticket => (
        <div key={`ticket-summary-row-${ticket.id}`}>
        <div className="col-sm-9 col-xs-8">{ticket.name}</div>
        <div className="col-sm-3 col-xs-4 text-right">
          <FeeInclusivePrice
            sum={ticket.price}
            eurSuffix
            pricingAsOf={ticket.sale_start_date}
          />
        </div>
      </div>
    ))

    if (ticketList.length === 0) {
      return null
    }

    return (
      <div className="section">
        <div className="break-lg" />

        <h2>
          <Translate value="shopping_basket.shopping_basket" />
        </h2>

        <div className="break-lg" />

        {eventContainers}

        <div className="break-lg" />

        <div className="delivery-info-container">
          <div className="row">
            <div className="col-md-4 col-sm-12">
              <div className="delivery-info">
                <h3 className="delivery-info-title">
                  <Translate value="shopping_basket.delivery_info" />
                </h3>

                <div className="break-md" />

                <form
                  id="email-form"
                  method="get"
                  onSubmit={this.handleToPayment}
                >
                  <label htmlFor="shopping-email" className="darker-label">
                    <Translate value="shopping_basket.email" />
                  </label>
                  <input
                    type="email"
                    id="shopping-email"
                    className="shopping-email-input"
                    value={email}
                    onChange={this.handleChange}
                    disabled={true}
                    required
                  />
                  <div className="break-sm" />

                  <small>
                    <Translate
                      value="shopping_basket.pdf_tickets"
                      className=""
                    />
                  </small>

                  <div className="break-sm" />

                  <label>
                    <input id="email" name="email" type="checkbox" required />
                    {I18n.t('shopping_basket.agree')}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="/termsofpurchaseandsale"
                    >
                      {I18n.t('shopping_basket.agree_title')}
                    </a>
                  </label>
                </form>
              </div>
            </div>

            <div className="col-md-8 col-sm-12">
              <div className="ticket-summary">
                <h3>
                  <Translate value="shopping_basket.ticket_summary" />
                </h3>

                <div className="row">
                  <div className="col-sm-9 col-xs-8 bold">
                    <Translate value="shopping_basket.ticket_name" />
                  </div>
                  <div className="col-sm-3 col-xs-4 bold text-right">
                    <Translate value="shopping_basket.price" />
                  </div>
                  {summary}
                </div>

                <div className="break-lg" />

                <div className="row">
                  <div className="col-sm-9 col-xs-8">
                    <Translate value="shopping_basket.ticket_price_total" />
                  </div>
                  <div className="col-sm-3 col-xs-4 text-right">
                    <RepresentMoney
                      sum={pricingBreakdown.resale_price_amount}
                      eurSuffix
                    />
                  </div>
                </div>

                {showBuyerServiceFee && (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-sm-9 col-xs-8">
                        <Translate value="shopping_basket.service_fee" />
                      </div>
                      <div className="col-sm-3 col-xs-4 text-right">
                        <RepresentMoney
                          sum={pricingBreakdown.buyer_service_fee_amount}
                          eurSuffix
                        />
                      </div>
                    </div>
                    <div className="text-right small">
                      <Translate
                        value="shopping_basket.service_fee_vat_included"
                      />
                    </div>
                  </React.Fragment>
                )}

                <div className="text-right">
                  <Translate value="shopping_basket.total_to_pay" />
                  <div className="bigbold">
                    <RepresentMoney
                      sum={pricingBreakdown.buyer_total_amount}
                      eurSuffix
                    />
                  </div>
                </div>

                <div className="break-md" />

                {ticketList.length > 0 && (
                  <div className="text-right">
                    <button
                      type="submit"
                      form="email-form"
                      disabled={!canProceedToPayment}
                    >
                      <Translate
                        style={{ textTransform: 'uppercase' }}
                        value="shopping_basket.proceed_to_payment"
                      />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const MapStateToProps = state => {
  return {
    eventList: state.shoppingBasket.eventInfo,
    ticketList: state.shoppingBasket.ticketList,
    endTime: state.shoppingBasket.endTime,
    totalPrice: state.shoppingBasket.totalPrice,
    userInfo: state.users.userInfo,
    email: state.shoppingBasket.email,
    errors: state.shoppingBasket.errors,
    validEvents: state.shoppingBasket.validEvents
  }
}

export default connect(MapStateToProps)(ShoppingBasket)
